import React, { useEffect } from "react";
import { Auth } from "aws-amplify";
import { IdleTimerProvider } from "react-idle-timer";
import axios from "axios";
import { Dialog } from "../Dialog";
import { LoaderUI } from "../Loader";
import { styled } from "@mui/material";
const DialogWapper = styled('div')(() => {
    return {
        '.MuiDialogTitle-root': {
            fontSize: '1.25rem',
            fontWeight: 500,
        },
        '.MuiDialogContent-root': {
            color: 'rgba(0, 0, 0, 0.54)'
        }
    };
});
export const IdleSessionHandle = (props) => {
    const timeoutInMinutes = 15;
    const timeInMilliseconds = 1000 * 60 * timeoutInMinutes;
    const [open, setOpen] = React.useState(false);
    const [loader, setLoader] = React.useState(false);
    useEffect(() => {
        let checkForSessionIntervalTime = 1000 * 60 * 2;
        let checkForSessionInterval = setInterval(() => {
            if (sessionStorage.getItem("USER_ACTIVE_SESSION") === "true") {
                axios
                    .get(process.env.REACT_APP_NEW_BASE_URL_NOTIFICATION +
                    "getSessionDetails/" +
                    localStorage.getItem("userMail") +
                    "/" +
                    sessionStorage.getItem("TYPE"))
                    .then((response) => {
                    console.log(response);
                    if (response.data.code === 200) {
                        if (!response.data.response.activeflag) {
                            appLogout();
                        }
                    }
                    else {
                        appLogout();
                    }
                });
            }
            else if (sessionStorage.getItem("USER_ACTIVE_SESSION") === "false") {
                appLogout();
            }
            else {
                Auth.currentAuthenticatedUser()
                    .then((user) => {
                    console.log("user available", user);
                })
                    .catch((err) => {
                    console.log("no session available", err);
                    appLogout();
                });
            }
        }, checkForSessionIntervalTime);
        return () => clearInterval(checkForSessionInterval);
    }, []);
    const handleClose = () => {
        var _a;
        sessionStorage.clear();
        setOpen(false);
        setLoader(false);
        (_a = props === null || props === void 0 ? void 0 : props.onCallback) === null || _a === void 0 ? void 0 : _a.call(props, "SignOut");
    };
    const handleOnIdle = () => {
        appLogout();
        console.log("app is idle now");
    };
    const appLogout = () => {
        setOpen(true);
        if (sessionStorage.getItem("USER_ACTIVE_SESSION") === "true") {
            let obj = {
                email: localStorage.getItem("userMail"),
                type: sessionStorage.getItem("TYPE"),
                activeflag: false,
            };
            axios
                .post(process.env.REACT_APP_NEW_BASE_URL_NOTIFICATION + "updateSession", obj)
                .then((response) => {
                localStorage.clear();
                sessionStorage.clear();
            })
                .catch((err) => {
                console.log(err);
            });
        }
        else {
            Auth.signOut();
            localStorage.clear();
            sessionStorage.clear();
        }
    };
    return (React.createElement("div", null,
        loader ? React.createElement(LoaderUI, null) : null,
        React.createElement(IdleTimerProvider, { timeout: timeInMilliseconds, onIdle: handleOnIdle, debounce: 250 }),
        React.createElement(DialogWapper, null,
            React.createElement(Dialog, { buttons: [
                    {
                        label: "Okay",
                        onClick: handleClose,
                    },
                ], handleCallback: handleClose, show: open, title: "Session Expired", key: "Session Expired", body: () => (React.createElement("p", null, "Your session has been expired. Please try logging again!")) }))));
};
